// 公共组件意见与反馈
export default {
    'feedback.name': 'Feedback',
    'feedback.upload': 'upload image',
}
 